import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d382d58a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d382d58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d382d58a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d382d58a')) {
      api.createRecord('d382d58a', component.options)
    } else {
      api.reload('d382d58a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d382d58a&scoped=true&", function () {
      api.rerender('d382d58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2My6bZ5o4m28f/JS/comp/GuestBox.vue"
export default component.exports